<template>
    <div>
        <slot>
            <label>
                <span v-if="label" v-text="label"></span>
                <span
                    class="validation"
                    :class="validationDisplayClass"
                    v-show="errors.has(name)"
                >
                    <span
                        v-for="(message, index) in validation"
                        v-show="errors.display(name, index)"
                        v-text="message"
                    ></span>
                </span>
            </label>
        </slot>
        <div ref="captcha" class="captcha-field"></div>
    </div>
</template>
<script>
    import EventMixin from "../mixins/EventMixin";
    export default {
        props: {
            group: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false
            },
            errors: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                default: () => { return {} }
            },
            validationDisplayClass: {
                type: String,
                default: ''
            },
            manualInitiation: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loads: 0,
                instanceId: null,
                eventMixin: new EventMixin(this.group),
            }
        },
        created() {
            EventBus.listen(this.eventMixin.target('success'), this.reset);
            EventBus.listen(this.eventMixin.target('failure'), this.reset);
        },
        mounted() {
            this.loadCaptcha();
        },
        methods: {
            delayCaptcha() {
                this.loads = this.loads+1;
                if (this.loads === 3) {
                    return;
                }
                setTimeout(this.loadCaptcha, 1000);
            },
            loadCaptcha() {
                let key = document.head.querySelector('meta[name="captcha-site-key"]');
                key = key ? key.content : null;
                if (!key) {
                    this.clear();
                    return;
                }

                if (!window.hasOwnProperty('grecaptcha') || !window.grecaptcha.hasOwnProperty('render')) {
                    this.delayCaptcha();
                    return;
                }

                this.instanceId = grecaptcha.render(this.$refs.captcha, {
                    'sitekey': key,
                    'callback': this.verifyCallBack,
                    'expired-callback': this.clear,
                    'error-callback': this.error,
                });
            },
            verifyCallBack(token) {
                this.$emit('input', token);
            },
            clear() {
                this.$emit('input', '');
            },
            reset() {
                grecaptcha.reset(this.instanceId);
            },
            error() {
                this.clear();
                console.log('Captcha script could not be loaded');
            }
        }
    }
</script>